import { useQuery } from '@apollo/client'
import { Tabs } from 'antd'
import React, { useState } from 'react'
import { ReportTap } from '../../components'
import { GET_REPORTS } from '../../Graphql/queries/getQueries'

const ReportTapsTemplate = ({
    enquiryTapTitels = [],
    enquiryPaths = []

}) => {
    const [path, setPath] = useState("")
    const [page, setPage] = useState(1);
    const { error, loading, data, refetch } = useQuery(GET_REPORTS, {
        variables: {
            path,
            // page
        },
        fetchPolicy: 'network-only'
    })

    const enquiryReportData = data?.Report?.nodes.map((report) => ({
        value: report.value, name: report.name, percentage: report.percent, color: report.color,
    }))
    const tableMap = (e, i) => {
        return {
            key: i,
            name: e.name,
            total_enquiries: e.value,
            percentage: e.percentage + '%',
        }
    }
    const columnsMap = (e) => {
        return [{
            title: e,
            dataIndex: 'name',
            key: 'name',
            render: (record) => e === 'Flow' ? (<span dangerouslySetInnerHTML={{ __html: record }}></span>) : record
        },
        {
            title: 'Total enquiries',
            dataIndex: 'total_enquiries',
            key: 'total_enquiries',
            // render: (record) => (<Link to='/enquiry'>{record} </Link>)
        },
        {
            title: 'Percentage',
            dataIndex: 'percentage',
            key: 'percentage',
        }]
    }

    const enkuiryTableData = enquiryReportData?.map(tableMap)
    // render All columns together
    const enkuiryColumns = enquiryTapTitels.map(columnsMap)

    const enquiryTaps = enquiryPaths.map((path, i) => (
        {
            key: i,
            title: enquiryTapTitels[i],
            columns: enkuiryColumns[i],
            path: path

        }
    ))


    const onchangePath = (path) => {
        setPath(path)
    }

    const items = enquiryTaps.map((tap) => (
        {
            key: tap.key,
            label: tap.title,
            children: <ReportTap
                total={data?.Report.total}
                chartData={enquiryReportData}
                loading={loading}
                tableData={enkuiryTableData}
                columns={tap.columns}
                path={tap.path}
                flow={tap.title === 'Flow' ? true : false}
                onPageChange={(page) => setPage(page)}
                onPathChange={onchangePath} />
        }
    ))



    return (
        <Tabs
            defaultActiveKey="1"
            items={items}
        // onChange={onChange}
        />
    )
}

export default ReportTapsTemplate